module.exports = __webpack_public_path__ + "static/media/waves-audio.95de25b4.gif";